import { Component } from '@angular/core';

@Component({
  selector: 'app-recu-bn-recep',
  templateUrl: './recu-bn-recep.component.html',
  styleUrls: ['./recu-bn-recep.component.scss']
})
export class RecuBnRecepComponent {}
